/**
 * Ultimate 432Hz Converter
 *
 * Declares one web-accessible-resource group — the `circles/*.svg` and `icons/*` image
 * sets plus several named HTML pages (sidepanel, engagement, revert-notification, popup,
 * offscreen) — matched to http(s) origins with no `use_dynamic_url`. So every bundled
 * icon and page is fetchable from any page at a fixed URL that carries the extension ID.
 *
 * The vendor icons load through `probeImage` with no CORS grant, so they survive a
 * restrictive page CSP; a successful load is conclusive.
 *
 * Manifest verified against version 1.5.2.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ebjidplbhbakkfpkofpmfhhdgpdajffh';

export const ultimate432HzConverter: ExtensionDefinition = {
  id: ID,
  name: 'Ultimate 432Hz Converter : Spotify YouTube Tidal & All Web Music Streaming',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 4_000,
  notes:
    'Icons, circle SVGs and several named HTML pages exposed to http(s) origins with no ' +
    'dynamic URL. The vendor icons are conclusive and load without a CORS grant.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icons/128.png via <img> — an app icon exposed to every http(s) origin; needs ' +
        'no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'icons/128.png'),
    },
    {
      id: 'war-revert-notification-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch revert-notification.html — a distinctively named page exposed alongside the ' +
        'icons, corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'revert-notification.html'),
    },
    {
      id: 'war-gpt-search-icon',
      kind: 'web-accessible-resource',
      description: 'Load icons/gptSearch.png via <img> — a second vendor-named icon path.',
      weight: 0.5,
      run: () => probeImage(ID, 'icons/gptSearch.png'),
    },
  ],
};
